export default __webpack_public_path__ + "static/eclipse-c331eadff32f7c409bcb2799f26ab2a7.png";